(function () {
  var targetPath = '/products/spine-twist-stretch-trainer-lw-2-spanish';
  if (window.location.pathname.indexOf(targetPath) === -1) return;

  function fixString(value) {
    return String(value || '').replace(/\bContacto{2,}\b/g, 'Contacto').replace(/\bContact\b/g, 'Contacto');
  }

  function fix(root) {
    var walker = document.createTreeWalker(root || document.body, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        return /Contact/.test(node.nodeValue || '') ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      }
    });
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function (node) {
      var next = fixString(node.nodeValue);
      if (next !== node.nodeValue) node.nodeValue = next;
    });

    ['alt', 'title', 'aria-label', 'placeholder'].forEach(function (attr) {
      document.querySelectorAll('[' + attr + ']').forEach(function (el) {
        var current = el.getAttribute(attr);
        var next = fixString(current);
        if (next !== current) el.setAttribute(attr, next);
      });
    });
  }

  var timer;
  function schedule() {
    window.clearTimeout(timer);
    timer = window.setTimeout(function () { fix(document.body); }, 20);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  window.setTimeout(schedule, 250);
  window.setTimeout(schedule, 1000);
})();
